import titleMixin from './titleMixin';
import errorMixin from './errorMixin';

export default {
  mixins: [titleMixin, errorMixin],
  data() {
    return {
      paginationStart: [{text: 'Użycie spowoduje przejście do poprzedniej strony'}, {text: 'Brak możliwości przejścia do poprzedniej strony'}],
      paginationEnd: [{text: 'Użycie spowoduje przejście do następnej strony'}, {text: 'Brak możliwości przejścia do następnej strony'}],
      dataIds: this.componentIds(),
      descriptionId: this.getSid('description'),
      lengthId: this.getSid('length')
    };
  },
  props: {
    labelledbyId: {
      type: String,
      default: null
    },
    mId: {
      type: String,
      default: null
    }
  },
  methods: {
    componentIds() {
      const sid = this.getSid();
      const errId = `err_${sid}`;
      const warnId = `warn_${sid}`;
      return {
        sid,
        errId,
        warnId
      };
    },
    getSid(subPrefix = '') {
      const prefix = this.setComponentName();
      return `${prefix}-${subPrefix}${!!subPrefix ? '-' : ''}${Math.round(Math.random() * 1000000)}`;
    },
    setComponentName() {
      const word = '[^w\\-$]';
      const name = this.$options.name;
      if (name && new RegExp(word).test(name)) {
        return name.substring(2, name.length);
      }
      return name;
    },
    checkLabelledby(fields) {
      const tmp = [];

      Object.keys(fields).map((x) => {
        switch (x) {
          case 'maxLength': {
            if (!!fields[x] && !!fields[x].lengthId && fields[x].isMaxLength) {
              tmp.push(fields[x].lengthId);
            }
            break;
          }
          case 'description': {
            if (!!fields[x] && !!fields[x].descriptionId && fields[x].isDescription) {
              tmp.push(fields[x].descriptionId);
            }
            break;
          }
          case 'labelledbyId': {
            if (!!fields[x]) {
              tmp.push(fields[x]);
            }
            break;
          }
        }
      });
      if (tmp.length) {
        return tmp.join(' ');
      }
      return undefined;
    }
  },
  computed: {
    activeAria() {
      if (!this.showLabel) return this.aria;
      return null;
    },
    setId() {
      if (this.mId) {
        return this.mId;
      }
      return this.dataIds.sid;
    }
  }
};
